import React from "react";
import { Link } from "react-router-dom";

import { Tag } from "antd";
import { FaCrown } from "react-icons/fa";
const PremiumTag = ({ size, hasIcon, height, fontSize, float, marginLeft }) => {
  if (!height) {
    height = "32px";
  }
  if (!fontSize) {
    fontSize = "15px";
  }
  if (!float) {
    float = "right";
  }
  if (!marginLeft) {
    marginLeft = "0px";
  }
  return (
    <Link to="/billing" style={{ cursor: "pointer" }}>
      <Tag
        color="#FDB62F"
        style={{
          float,
          fontSize,
          height,
          lineHeight: "32px",
          cursor: "pointer",
          marginLeft,
        }}
      >
        {hasIcon ? <FaCrown style={{ marginRight: "2px" }} /> : ""} PREMIUM
      </Tag>
    </Link>
  );
};

export default PremiumTag;
